import type {AxiosRequestConfig} from 'axios';
import {Vehicle} from './interface';

export class DeleteVehicleBuilder {
  private readonly vehicleRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.vehicleRequest.url = `/vehicles/${id}`;
    return this;
  }
  build() {
    return this.vehicleRequest;
  }
}
export class GetAllVehiclesRequestBuilder {
  private readonly vehicleRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/vehicles',
    params: {},
  };

  id(id: number) {
    this.vehicleRequest.url = `/vehicles/${id}`;
    return this;
  }

  params(params: object) {
    this.vehicleRequest.params = params;
    return this;
  }
  
  pageNumber(num: number) {
    this.vehicleRequest.params.pageNumber = num;
    return this;
  }
  pageSize(num: number) {
    this.vehicleRequest.params.pageSize = num;
    return this;
  }
  paged(paged: boolean) {
    this.vehicleRequest.params.paged = paged;
    return this;
  }

  build() {
    return this.vehicleRequest;
  }
}
export class GetVehiclesCountRequestBuilder {
  private readonly vehicleRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/vehicles/count',
  };

  id(id: number) {
    this.vehicleRequest.url = `/vehicles/${id}/`;
    return this;
  }

  build() {
    return this.vehicleRequest;
  }
}

export class GetVehiclePreferredSourcesRequestBuilder {
  private readonly vehicleRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
  };

  id(id: number) {
    this.vehicleRequest.url = `/vehicles/${id}/preferred-sources`;
    return this;
  }

  build() {
    return this.vehicleRequest;
  }
}

export class CreateVehicleRequestBuilder {
  private readonly vehicleRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/vehicles',
    data: {},
  };

  data(data: Vehicle) {
    this.vehicleRequest.data = data;
    return this;
  }

  build() {
    return this.vehicleRequest;
  }
}

export class UpdateVehiclePreferredSourcesRequestBuilder {
  private readonly vehicleRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.vehicleRequest.url = `/vehicles/${id}/preferred-sources`;
    return this;
  }

  data(body: number[]) {
    this.vehicleRequest.data = body;
    return this;
  }
  build() {
    return this.vehicleRequest;
  }
}

export class UpdateVehicleRequestBuilder {
  private readonly vehicleRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/vehicles',
    data: {},
  };
  data(body: Vehicle) {
    this.vehicleRequest.data = body;
    return this;
  }
  build() {
    return this.vehicleRequest;
  }
}
